<template>
  <v-container class="container-card">
    <v-card>
      <Individual />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Individual from "@/components/comissao/realizados/individual/Individual";
export default {
  components: {
    Individual
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Realizado Individual");
  }
};
</script>

<style></style>
